/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterDepartmentAddPost } from '../fn/department/api-master-department-add-post';
import { ApiMasterDepartmentAddPost$Params } from '../fn/department/api-master-department-add-post';
import { apiMasterDepartmentDeleteGet } from '../fn/department/api-master-department-delete-get';
import { ApiMasterDepartmentDeleteGet$Params } from '../fn/department/api-master-department-delete-get';
import { apiMasterDepartmentEditPost } from '../fn/department/api-master-department-edit-post';
import { ApiMasterDepartmentEditPost$Params } from '../fn/department/api-master-department-edit-post';
import { apiMasterDepartmentGetActiveGet } from '../fn/department/api-master-department-get-active-get';
import { ApiMasterDepartmentGetActiveGet$Params } from '../fn/department/api-master-department-get-active-get';
import { apiMasterDepartmentGetAllGet } from '../fn/department/api-master-department-get-all-get';
import { ApiMasterDepartmentGetAllGet$Params } from '../fn/department/api-master-department-get-all-get';
import { Department } from '../models/department';
import { DepartmentApiRespModel } from '../models/department-api-resp-model';
import { Int32ApiRespModel } from '../models/int-32-api-resp-model';

@Injectable({ providedIn: 'root' })
export class DepartmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterDepartmentAddPost()` */
  static readonly ApiMasterDepartmentAddPostPath = '/api/Master/Department/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDepartmentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterDepartmentAddPost$Response(params?: ApiMasterDepartmentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DepartmentApiRespModel>> {
    return apiMasterDepartmentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDepartmentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterDepartmentAddPost(params?: ApiMasterDepartmentAddPost$Params, context?: HttpContext): Observable<DepartmentApiRespModel> {
    return this.apiMasterDepartmentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<DepartmentApiRespModel>): DepartmentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterDepartmentEditPost()` */
  static readonly ApiMasterDepartmentEditPostPath = '/api/Master/Department/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDepartmentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterDepartmentEditPost$Response(params?: ApiMasterDepartmentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DepartmentApiRespModel>> {
    return apiMasterDepartmentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDepartmentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterDepartmentEditPost(params?: ApiMasterDepartmentEditPost$Params, context?: HttpContext): Observable<DepartmentApiRespModel> {
    return this.apiMasterDepartmentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<DepartmentApiRespModel>): DepartmentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterDepartmentDeleteGet()` */
  static readonly ApiMasterDepartmentDeleteGetPath = '/api/Master/Department/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDepartmentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDepartmentDeleteGet$Response(params?: ApiMasterDepartmentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
    return apiMasterDepartmentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDepartmentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDepartmentDeleteGet(params?: ApiMasterDepartmentDeleteGet$Params, context?: HttpContext): Observable<Int32ApiRespModel> {
    return this.apiMasterDepartmentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiRespModel>): Int32ApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterDepartmentGetAllGet()` */
  static readonly ApiMasterDepartmentGetAllGetPath = '/api/Master/Department/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDepartmentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDepartmentGetAllGet$Response(params?: ApiMasterDepartmentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Department>>> {
    return apiMasterDepartmentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDepartmentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDepartmentGetAllGet(params?: ApiMasterDepartmentGetAllGet$Params, context?: HttpContext): Observable<Array<Department>> {
    return this.apiMasterDepartmentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Department>>): Array<Department> => r.body)
    );
  }

  /** Path part for operation `apiMasterDepartmentGetActiveGet()` */
  static readonly ApiMasterDepartmentGetActiveGetPath = '/api/Master/Department/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDepartmentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDepartmentGetActiveGet$Response(params?: ApiMasterDepartmentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Department>>> {
    return apiMasterDepartmentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDepartmentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDepartmentGetActiveGet(params?: ApiMasterDepartmentGetActiveGet$Params, context?: HttpContext): Observable<Array<Department>> {
    return this.apiMasterDepartmentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Department>>): Array<Department> => r.body)
    );
  }

}
